import { EDistrict } from '@/domains/partners/multisport/enums/District'

export const DISTRICTS = [
  { value: EDistrict.DOLNOSLASKIE, text: 'form.district.dolnoslaskie' },
  { value: EDistrict.KUJAWSKO_POMORSKIE, text: 'form.district.kujawskopomorskie' },
  { value: EDistrict.LUBELSKIE, text: 'form.district.lubelskie' },
  { value: EDistrict.LUBUSKIE, text: 'form.district.lubuskie' },
  { value: EDistrict.LODZKIE, text: 'form.district.lodzkie' },
  { value: EDistrict.MALOPOLSKIE, text: 'form.district.malopolskie' },
  { value: EDistrict.MAZOWIECKIE, text: 'form.district.mazowieckie' },
  { value: EDistrict.OPOLSKIE, text: 'form.district.opolskie' },
  { value: EDistrict.PODKARPACKIE, text: 'form.district.podkarpackie' },
  { value: EDistrict.PODLASKIE, text: 'form.district.podlaskie' },
  { value: EDistrict.POMORSKIE, text: 'form.district.pomorskie' },
  { value: EDistrict.SLASKIE, text: 'form.district.slaskie' },
  { value: EDistrict.SWIETOKRZYSKIE, text: 'form.district.swietokrzyskie' },
  { value: EDistrict.WARMINSKO_MAZURSKIE, text: 'form.district.warminsko_mazurskie' },
  { value: EDistrict.WIELKOPOLSKIE, text: 'form.district.wielkopolskie' },
  { value: EDistrict.ZACHODNIOPOMORSKIE, text: 'form.district.zachodniopomorskie' },
]
